class OnstateMegaMenu extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.section = this.closest('.shopify-section');
    this.menuItems = this.querySelectorAll('nav > ul > li');

    // Event listeners
    this.section.addEventListener('mouseleave', this.onLeaveSection.bind(this));
    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', this.onHoverMenuItem.bind(this));
    });

    // Close menu on mouse leaving nav-row
    const navRow = this.closest('.nav-row');
    if (navRow) {
      navRow.addEventListener('mouseleave', this.onLeaveSection.bind(this));
    }
  }

  onHoverMenuItem(event) {

    const submenu = event.currentTarget.querySelector('.onstate-mega-menu__submenu');
    this.section.classList.remove('leaving');

    this.closeSubmenus();

    if (submenu) {
      this.closeDisclosures();
      this.openSubmenu(submenu);
    }
  }

  onLeaveSection(event) {
    this.section.classList.add('leaving');
    setTimeout(() => {
      if (this.section.classList.contains('leaving')) {
        this.closeSubmenus();
      }
    }, 450);
  }

  openSubmenu(submenu) {
    const menuItem = submenu.closest('.has-submenu').querySelector('a');
    if (menuItem) {
      menuItem.setAttribute('aria-expanded', true);
    }

    submenu.classList.add('is-visible');
    submenu.removeAttribute('tabindex');
    submenu.setAttribute('aria-hidden', false);
  }

  closeSubmenu(submenu) {
    const menuItem = submenu.closest('.has-submenu').querySelector('a');
    if (menuItem) {
      menuItem.setAttribute('aria-expanded', false);
    }

    submenu.classList.remove('is-visible');
    submenu.setAttribute('tabindex', '-1');
    submenu.setAttribute('aria-hidden', true);
  }

  closeSubmenus() {
    const submenus = this.querySelectorAll('.onstate-mega-menu__submenu');
    submenus.forEach(submenu => this.closeSubmenu(submenu));
  }

  closeDisclosures() {
    const disclosures = this.querySelectorAll('details-disclosure');
    disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('onstate-mega-menu', OnstateMegaMenu);